enum DividerColors {
	Primary = 'rgb(128, 136, 149)',
	Secondary = 'rgb(255, 255, 255)',
}

export default DividerColors;
